import { css } from 'styled-components';

const storeSpecialPriceTagStyle = css`
  &.price-tag-container {
    .special-label {
      color: #000;
      font-family: Nunito;
      font-size: 10px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      background-color: #ffdede;
      border-radius: 4px;
      padding: 2px 6px;
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .pickup-label {
      color: #000;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Nunito;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 150%; /* 21px */
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        font-size: 12px;
        font-weight: 500;
      }
    }

    .final-price {
      color: #c8102e;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Nunito;
      font-size: 14px;
      font-style: normal;
      font-weight: 800;
      line-height: 150%;
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        padding-left: 2px;
      }
    }
    .price-display-qv {
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        display: flex;
        flex-direction: row;
        gap: 2px;
        align-items: center;
      }
    }
  }
`;

export default storeSpecialPriceTagStyle;
